export const isRequire = (value) => {
  return value ? true : false
}

export const isNumeric = (value = '') => {
  value = `${value}`
  if (value.match(/^-{0,1}\d+$/)) {
    return true
  } else if (value.match(/^\d+\.\d+$/)) {
    return true
  } else {
    return false
  }
}

export const isDigit = (value = '') => {
  return value&&value.match(/^-{0,1}\d+$/) ? true : false
}

export const isInteger = (value = '') => {
  return value&&value.match(/^-{0,1}\d+$/) ? true : false
}

export const isPositiveInteger = (value = '') => {
  return value.match(/^\d*[1-9]\d*$/) ? true : false
}

export const isEmail = (value = '') => {
  return value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i) ? true : false
}

export const minLength = (value, length) => {
  return value.length >= length
}

export const maxLength = (value, length) => {
  return value.length <= length
}

export const maxLength10 = (value) => {
  return maxLength(value || '', 10)
}

export const maxLength13 = (value) => {
  return maxLength(value || '', 13)
}

export const maxLength18 = (value) => {
  return maxLength(value || '', 18)
}

export const maxLength20 = (value) => {
  return maxLength(value || '', 20)
}

export const maxLength25 = (value) => {
  return maxLength(value || '', 25)
}

export const maxLength30 = (value) => {
  return maxLength(value || '', 30)
}

export const maxLength40 = (value) => {
  return maxLength(value || '', 40)
}

export const maxLength50 = (value) => {
  return maxLength(value || '', 50)
}

export const maxLength60 = (value) => {
  return maxLength(value || '', 60)
}

export const maxLength200 = (value) => {
  return maxLength(value || '', 200)
}

export const validateCase = {
  require: 'require',
  number: 'number',
  digit: 'digit',
  integer: 'integer',
  positiveInteger: 'positiveInteger',
  email: 'email',
  maxLength10: 'maxLength10',
  maxLength13: 'maxLength13',
  maxLength18: 'maxLength18',
  maxLength20: 'maxLength20',
  maxLength25: 'maxLength25',
  maxLength30: 'maxLength30',
  maxLength40: 'maxLength40',
  maxLength50: 'maxLength50',
  maxLength60: 'maxLength60',
  maxLength200: 'maxLength200',
}

export const validation = (values, key, validateCases = [], errors) => {
  validateCases.forEach(v => {
    if (v === validateCase.require) {
      if (!isRequire(values[key])) 
        errors[key] = errors[key] ? errors[key] + ', Require!' : 'Require!'
    } else if (v === validateCase.number) {
      if (!isNumeric(values[key])) 
        errors[key] = errors[key] ? errors[key] + ', Numeric Only!' : 'Numeric Only!'
    } else if (v === validateCase.digit) {
      if (!isDigit(values[key])) 
        errors[key] = errors[key] ? errors[key] + ', Digit Only!' : 'Digit Only!'
    } else if (v === validateCase.integer) {
      if (!isInteger(values[key])) 
        errors[key] = errors[key] ? errors[key] + ', Integer Only!' : 'Integer Only!'
    } else if (v === validateCase.positiveInteger) {
      if (!isPositiveInteger(values[key])) 
        errors[key] = errors[key] ? errors[key] + ', Positive integer Only!' : 'Positive integer Only!'
    } else if (v === validateCase.email) {
      if (!isEmail(values[key])) 
        errors[key] = errors[key] ? errors[key] + ', This email is wrong format!' : 'This email is wrong format!'
    } else if (v === validateCase.maxLength10) {
      if (!maxLength10(values[key])) 
        errors[key] = errors[key] ? errors[key] + ', Value length not more than 10!' : 'Value length not more than 10!'
    } else if (v === validateCase.maxLength13) {
      if (!maxLength13(values[key])) 
        errors[key] = errors[key] ? errors[key] + ', Value length not more than 13!' : 'Value length not more than 13!'
    } else if (v === validateCase.maxLength18) {
      if (!maxLength18(values[key])) 
        errors[key] = errors[key] ? errors[key] + ', Value length not more than 18!' : 'Value length not more than 18!'
    } else if (v === validateCase.maxLength20) {
      if (!maxLength20(values[key])) 
        errors[key] = errors[key] ? errors[key] + ', Value length not more than 20!' : 'Value length not more than 20!'
    } else if (v === validateCase.maxLength25) {
      if (!maxLength25(values[key])) 
        errors[key] = errors[key] ? errors[key] + ', Value length not more than 25!' : 'Value length not more than 25!'
    } else if (v === validateCase.maxLength30) {
      if (!maxLength30(values[key])) 
        errors[key] = errors[key] ? errors[key] + ', Value length not more than 30!' : 'Value length not more than 30!'
    } else if (v === validateCase.maxLength40) {
      if (!maxLength40(values[key])) 
        errors[key] = errors[key] ? errors[key] + ', Value length not more than 40!' : 'Value length not more than 40!'
    } else if (v === validateCase.maxLength50) {
      if (!maxLength50(values[key])) 
        errors[key] = errors[key] ? errors[key] + ', Value length not more than 50!' : 'Value length not more than 50!'
    } else if (v === validateCase.maxLength60) {
      if (!maxLength60(values[key])) 
        errors[key] = errors[key] ? errors[key] + ', Value length not more than 60!' : 'Value length not more than 60!'
    } else if (v === validateCase.maxLength200) {
      if (!maxLength200(values[key]))
        errors[key] = errors[key] ? errors[key] + ', Title must be less than or equal to 200 characters' : 'Title must be less than or equal to 200 characters'
    }
  })

  return errors
}

export const validations = (values, key, validateCases = [], errors) => {
  validateCases.forEach(v => {
    if (v === validateCase.require) {
      if (!isRequire(values[key])) 
        errors[key] = errors[key] ? errors[key] + ', Require!' : 'Require!'
    } else if (v === validateCase.number) {
      if (!isNumeric(values[key])) 
        errors[key] = errors[key] ? errors[key] + ', Numeric Only!' : 'Numeric Only!'
    } else if (v === validateCase.digit) {
      if (!isDigit(values[key])) 
        errors[key] = errors[key] ? errors[key] + ', Digit Only!' : 'Digit Only!'
    } else if (v === validateCase.integer) {
      if (!isInteger(values[key])) 
        errors[key] = errors[key] ? errors[key] + ', Integer Only!' : 'Integer Only!'
    } else if (v === validateCase.positiveInteger) {
      if (!isPositiveInteger(values[key])) 
        errors[key] = errors[key] ? errors[key] + ', Positive integer Only!' : 'Positive integer Only!'
    } else if (v === validateCase.email) {
      if (!isEmail(values[key])) 
        errors[key] = errors[key] ? errors[key] + ', This email is wrong format!' : 'This email is wrong format!'
    } else if (v === validateCase.maxLength10) {
      if (!maxLength10(values[key])) 
        errors[key] = errors[key] ? errors[key] + ', Value length not more than 10!' : 'Value length not more than 10!'
    } else if (v === validateCase.maxLength13) {
      if (!maxLength13(values[key])) 
        errors[key] = errors[key] ? errors[key] + ', Value length not more than 13!' : 'Value length not more than 13!'
    } else if (v === validateCase.maxLength18) {
      if (!maxLength18(values[key])) 
        errors[key] = errors[key] ? errors[key] + ', Value length not more than 18!' : 'Value length not more than 18!'
    } else if (v === validateCase.maxLength20) {
      if (!maxLength20(values[key])) 
        errors[key] = errors[key] ? errors[key] + ', Value length not more than 20!' : 'Value length not more than 20!'
    } else if (v === validateCase.maxLength25) {
      if (!maxLength25(values[key])) 
        errors[key] = errors[key] ? errors[key] + ', Value length not more than 25!' : 'Value length not more than 25!'
    } else if (v === validateCase.maxLength30) {
      if (!maxLength30(values[key])) 
        errors[key] = errors[key] ? errors[key] + ', Value length not more than 30!' : 'Value length not more than 30!'
    } else if (v === validateCase.maxLength40) {
      if (!maxLength40(values[key])) 
        errors[key] = errors[key] ? errors[key] + ', Value length not more than 40!' : 'Value length not more than 40!'
    } else if (v === validateCase.maxLength50) {
      if (!maxLength50(values[key])) 
        errors[key] = errors[key] ? errors[key] + ', Value length not more than 50!' : 'Value length not more than 50!'
    } else if (v === validateCase.maxLength60) {
      if (!maxLength60(values[key])) 
        errors[key] = errors[key] ? errors[key] + ', Value length not more than 60!' : 'Value length not more than 60!'
    } else if (v === validateCase.maxLength200) {
      if (!maxLength200(values[key]))
        errors[key] = errors[key] ? errors[key] + ', Title must be less than or equal to 200 characters' : 'Title must be less than or equal to 200 characters'
    }
  })
}
